import { useTranslation } from '@wix/yoshi-flow-editor';
import type { FC } from 'react';
import React from 'react';

import MemberName from '../../../../../../../common/components/MemberName';
import RoleIcons from '../../../../../../../common/components/RoleIcons';
import { useWidget } from '../../../../../../../contexts/widgets';
import { DataHook } from '../../../../../../../types';
import styles from './Name.scss';

export const Name: FC = () => {
  const { t } = useTranslation();
  const { member, site, rolesMap, computed } = useWidget();

  const { showRoleLabel, memberNameHtmlTags } = computed;
  const { isSocial } = site;

  return (
    <div data-hook={DataHook.MemberName} className={styles.container}>
      <div className={styles.nameWrapper}>
        <MemberName
          name={member.name}
          className={styles.nameBoxText}
          tooltipClass={styles.tooltipWrapper}
          htmlTag={memberNameHtmlTags.responsive}
        />
      </div>
      {isSocial && showRoleLabel && (
        <RoleIcons
          t={t}
          containerClassName={styles.roleIcons}
          iconClassName={styles.roleIcon}
          roles={member.roles}
          rolesMap={rolesMap}
          withNames={true}
        />
      )}
    </div>
  );
};
